module.exports = __webpack_public_path__ + "static/media/footer_vk.19a5ae49.svg";